export const AMPLITUDE_API_KEY = 'dc5214b6394e3c38171fb7ef5d18f641'
